"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.synchronizeQuantityWithPrice = exports.synchronizePriceWithQuantity = exports.showBuySellSuccessMessage = exports.showBuySellFailMessage = exports.sendOrder = exports.sellQuantityClicked = exports.sellPriceClicked = exports.placeOrderWithChecks = exports.placeOrder = exports.clearOrderForm = exports.clearBuySellForm = exports.buyQuantityClicked = exports.buyPriceClicked = void 0;
var _reduxForm = require("redux-form");
var _apiActions = require("./apiActions");
var _bignumber = _interopRequireDefault(require("bignumber.js"));
var _placeOrderHelper = require("../../helpers/placeOrderHelper");
var _orderEntryFormConstants = require("../../constants/sendOrder/orderEntryFormConstants");
var _modalActions = require("./modalActions");
var _snackbarActions = require("./snackbarActions");
var _orderFormTypes = require("../../constants/sendOrder/orderFormTypes");
var _orderHelper = require("../../helpers/orderHelper");
var _errorTextFormatter = require("../../helpers/errorTextFormatter");
var _instrumentPositionSelectors = require("../selectors/instrumentPositionSelectors");
var _selectors = require("../margin/selectors");
var _decimalPlacesHelper = require("../../helpers/decimalPlaces/decimalPlacesHelper");
var _numberFormatter = require("../../helpers/numberFormatter");
var _level2Selectors = require("../selectors/level2Selectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var placeOrderWithChecks = exports.placeOrderWithChecks = function placeOrderWithChecks(orderFormType, form, formName) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(dispatch, getState) {
      var _getState, apexCore, level1, instrument, limitPrice, bestOffer, bestBid;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _getState = getState(), apexCore = _getState.apexCore;
            level1 = apexCore.level1, instrument = apexCore.instrument;
            limitPrice = new _bignumber["default"](form.limitPrice);
            if (!(form.orderType === _orderEntryFormConstants.orderTypes.limit.displayName && form.side === _orderEntryFormConstants.buyValue)) {
              _context.next = 7;
              break;
            }
            bestOffer = new _bignumber["default"](level1[instrument.selectedInstrumentId.toString()].BestOffer);
            if (!(limitPrice.gt(bestOffer) && bestOffer.gt(0))) {
              _context.next = 7;
              break;
            }
            return _context.abrupt("return", dispatch((0, _modalActions.openModal)(_modalActions.MODAL_TYPES.ORDER_WARNING, {
              side: 'buy',
              orderFormType: orderFormType,
              form: form,
              formName: formName
            })));
          case 7:
            if (!(form.orderType === _orderEntryFormConstants.orderTypes.limit.displayName && form.side === _orderEntryFormConstants.sellValue)) {
              _context.next = 11;
              break;
            }
            bestBid = new _bignumber["default"](level1[instrument.selectedInstrumentId.toString()].BestBid);
            if (!(limitPrice.lt(bestBid) && bestBid.gt(0))) {
              _context.next = 11;
              break;
            }
            return _context.abrupt("return", dispatch((0, _modalActions.openModal)(_modalActions.MODAL_TYPES.ORDER_WARNING, {
              side: 'sell',
              orderFormType: orderFormType,
              form: form,
              formName: formName
            })));
          case 11:
            return _context.abrupt("return", dispatch((0, _modalActions.openModal)(_modalActions.MODAL_TYPES.CONFIRM_ORDER_REPORT, {
              orderFormType: orderFormType,
              formName: formName
            })));
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
var sendOrder = exports.sendOrder = function sendOrder(options) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(dispatch) {
      var res;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return dispatch((0, _apiActions.callAPI)('SendOrder', options));
          case 3:
            res = _context2.sent;
            if (!(res.status === 'Rejected' && res.errormsg === 'Margin_Account_In_Liquidation')) {
              _context2.next = 8;
              break;
            }
            return _context2.abrupt("return", dispatch((0, _snackbarActions.showSnack)({
              id: 'sendOrderRejectSnackbar',
              text: 'It is not permissible to place an order while your account is in liquidation. Please try again when your account is no longer in liquidation.',
              type: 'warning'
            })));
          case 8:
            if (!(res.result === false || res.status === 'Rejected')) {
              _context2.next = 10;
              break;
            }
            return _context2.abrupt("return", dispatch((0, _snackbarActions.showSnack)({
              id: 'sendOrderRejectSnackbar',
              text: (0, _errorTextFormatter.formatErrorText)(res),
              type: 'warning'
            })));
          case 10:
            _context2.next = 15;
            break;
          case 12:
            _context2.prev = 12;
            _context2.t0 = _context2["catch"](0);
            console.error('sendOrder action error', _context2.t0);
          case 15:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[0, 12]]);
    }));
    return function (_x3) {
      return _ref2.apply(this, arguments);
    };
  }();
};
var placeOrder = exports.placeOrder = function placeOrder(orderFormType, form) {
  var _ref3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    useNewForm = _ref3.useNewForm;
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(dispatch, getState) {
      var state, selectedAccountId, _getState2, userInfo, _getState2$apexCore, product, level1, level2, selectedInstrument, priceDecimalPlaces, quantityDecimalPlaces, options, response;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            state = getState();
            selectedAccountId = (0, _selectors.selectedAccountIdSelector)(state);
            _getState2 = getState(), userInfo = _getState2.user.userInfo, _getState2$apexCore = _getState2.apexCore, product = _getState2$apexCore.product, level1 = _getState2$apexCore.level1, level2 = _getState2$apexCore.level2;
            selectedInstrument = (0, _instrumentPositionSelectors.selectedInstrumentSelector)(getState());
            priceDecimalPlaces = (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(selectedInstrument.PriceIncrement);
            quantityDecimalPlaces = (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(selectedInstrument.QuantityIncrement);
            options = (0, _placeOrderHelper.getFormValuesForSubmittingOrder)(orderFormType, {
              state: getState(),
              decimalPlaces: product.decimalPlaces,
              instrument: {
                selectedInstrumentId: selectedInstrument.InstrumentId
              },
              form: form,
              userInfo: userInfo,
              selectedAccountId: selectedAccountId,
              priceDecimalPlaces: priceDecimalPlaces,
              quantityDecimalPlaces: quantityDecimalPlaces,
              level1: level1,
              level2: level2,
              useNewForm: useNewForm
            });
            if (!(orderFormType === _orderFormTypes.orderFormTypes.block)) {
              _context3.next = 13;
              break;
            }
            _context3.next = 10;
            return dispatch((0, _apiActions.callAPI)('SubmitBlockTrade', options));
          case 10:
            response = _context3.sent;
            _context3.next = 16;
            break;
          case 13:
            _context3.next = 15;
            return dispatch(sendOrder(options));
          case 15:
            response = _context3.sent;
          case 16:
            return _context3.abrupt("return", response);
          case 17:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function (_x4, _x5) {
      return _ref4.apply(this, arguments);
    };
  }();
};
var buyPriceClicked = exports.buyPriceClicked = function buyPriceClicked(price) {
  return function (dispatch, getState) {
    var state = getState();
    if (!state.form.orderEntry) return;
    var selectedOrderType = state.form.orderEntry.values.orderType;
    var isStopOrder = selectedOrderType === _orderEntryFormConstants.orderTypes.stopMarket.displayName;
    var _selectedInstrumentSe = (0, _instrumentPositionSelectors.selectedInstrumentSelector)(state),
      PriceIncrement = _selectedInstrumentSe.PriceIncrement;
    var convertedPriceIncrement = (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(PriceIncrement);
    if (!isStopOrder) {
      dispatch(checkAndSwitchToLimitOrderType());
    }
    dispatch((0, _reduxForm.change)('orderEntry', 'side', _orderEntryFormConstants.sellValue));
    dispatch(clearFeeAndTotalAmountValues('orderEntry'));
    dispatch((0, _reduxForm.change)('orderEntry', isStopOrder ? 'stopPrice' : 'limitPrice', (0, _numberFormatter.truncateToDecimals)(parseFloat(price), convertedPriceIncrement)));
  };
};
var buyQuantityClicked = exports.buyQuantityClicked = function buyQuantityClicked(e) {
  return function (dispatch, getState) {
    e.persist();
    var _e$currentTarget$data = e.currentTarget.dataset,
      quantity = _e$currentTarget$data.quantity,
      index = _e$currentTarget$data.index;
    dispatch(clearFeeAndTotalAmountValues('orderEntry'));
    var state = getState();
    var buy = (0, _level2Selectors.level2BuySelector)(state, {
      filterMode: 'selectedInstrumentId'
    });
    var _selectedInstrumentSe2 = (0, _instrumentPositionSelectors.selectedInstrumentSelector)(state),
      QuantityIncrement = _selectedInstrumentSe2.QuantityIncrement;
    var convertedQuantityIncrement = (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(QuantityIncrement);
    var overallQuantity = calculateQuantity((0, _numberFormatter.truncateToDecimals)(quantity, convertedQuantityIncrement), buy, index);
    dispatch((0, _reduxForm.change)('orderEntry', 'quantity', overallQuantity));
    dispatch((0, _reduxForm.change)('orderEntry', 'side', _orderEntryFormConstants.sellValue));
    dispatch((0, _reduxForm.change)('orderEntry', 'orderType', _orderEntryFormConstants.orderTypes.market.displayName));
  };
};
var sellPriceClicked = exports.sellPriceClicked = function sellPriceClicked(price) {
  return function (dispatch, getState) {
    var state = getState();
    if (!state.form.orderEntry) return;
    var selectedOrderType = state.form.orderEntry.values.orderType;
    var isStopOrder = selectedOrderType === _orderEntryFormConstants.orderTypes.stopMarket.displayName;
    dispatch(clearFeeAndTotalAmountValues('orderEntry'));
    if (!isStopOrder) {
      dispatch(checkAndSwitchToLimitOrderType());
    }
    var _selectedInstrumentSe3 = (0, _instrumentPositionSelectors.selectedInstrumentSelector)(state),
      PriceIncrement = _selectedInstrumentSe3.PriceIncrement;
    var convertedPriceIncrement = (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(PriceIncrement);
    dispatch((0, _reduxForm.change)('orderEntry', isStopOrder ? 'stopPrice' : 'limitPrice', (0, _numberFormatter.truncateToDecimals)(parseFloat(price), convertedPriceIncrement)));
    dispatch((0, _reduxForm.change)('orderEntry', 'side', _orderEntryFormConstants.buyValue));
  };
};
var sellQuantityClicked = exports.sellQuantityClicked = function sellQuantityClicked(e) {
  return function (dispatch, getState) {
    e.persist();
    var _e$currentTarget$data2 = e.currentTarget.dataset,
      quantity = _e$currentTarget$data2.quantity,
      index = _e$currentTarget$data2.index;
    dispatch(clearFeeAndTotalAmountValues('orderEntry'));
    var state = getState();
    var sell = (0, _level2Selectors.level2SellSelector)(state, {
      filterMode: 'selectedInstrumentId'
    });
    var _selectedInstrumentSe4 = (0, _instrumentPositionSelectors.selectedInstrumentSelector)(state),
      QuantityIncrement = _selectedInstrumentSe4.QuantityIncrement;
    var convertedQuantityIncrement = (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(QuantityIncrement);
    var overallQuantity = calculateQuantity((0, _numberFormatter.truncateToDecimals)(quantity, convertedQuantityIncrement), sell, index, false);
    dispatch((0, _reduxForm.change)('orderEntry', 'quantity', overallQuantity));
    dispatch((0, _reduxForm.change)('orderEntry', 'side', _orderEntryFormConstants.buyValue));
    dispatch((0, _reduxForm.change)('orderEntry', 'orderType', _orderEntryFormConstants.orderTypes.market.displayName));
  };
};
var clearOrderForm = exports.clearOrderForm = function clearOrderForm(formName) {
  return function (dispatch) {
    dispatch(clearFeeAndTotalAmountValues(formName));
    dispatch((0, _reduxForm.reset)(formName));
  };
};
var clearBuySellForm = exports.clearBuySellForm = function clearBuySellForm(formName) {
  return function (dispatch) {
    var form = formName || 'buySell';
    dispatch(clearField(form, 'quantity', ''));
    dispatch(clearField(form, 'price', ''));
    dispatch(clearField(form, 'amountRadio', 'custom'));
    dispatch(clearField(form, 'limitPrice', ''));
    dispatch(clearField(form, 'fee', '0'));
    dispatch(clearField(form, 'responseMessage', ''));
  };
};
var showBuySellSuccessMessage = exports.showBuySellSuccessMessage = function showBuySellSuccessMessage() {
  return function (dispatch) {
    // t('Your order was filled successfully!')
    dispatch((0, _reduxForm.change)('buySell', 'responseMessage', 'Your order was filled successfully!'));
  };
};
var showBuySellFailMessage = exports.showBuySellFailMessage = function showBuySellFailMessage() {
  return function (dispatch) {
    // t('Your order failed, please try again')
    dispatch((0, _reduxForm.change)('buySell', 'responseMessage', 'Your order failed, please try again'));
  };
};
var synchronizeQuantityWithPrice = exports.synchronizeQuantityWithPrice = function synchronizeQuantityWithPrice(price, form, field, formObj) {
  return function (dispatch, getState) {
    var _getState3 = getState(),
      _getState3$apexCore = _getState3.apexCore,
      level2 = _getState3$apexCore.level2,
      decimalPlaces = _getState3$apexCore.product.decimalPlaces;
    var selectedInstrument = (0, _instrumentPositionSelectors.selectedInstrumentSelector)(getState());
    var quantity = (0, _orderHelper.syncQuantityWithPrice)(price, {
      level2: level2,
      selectedInstrument: selectedInstrument,
      side: formObj.values.side,
      decimalPlaces: decimalPlaces
    });
    dispatch((0, _reduxForm.change)(form, field, quantity));
  };
};
var synchronizePriceWithQuantity = exports.synchronizePriceWithQuantity = function synchronizePriceWithQuantity(quantity, form, field, formObj) {
  return function (dispatch, getState) {
    var _getState4 = getState(),
      _getState4$apexCore = _getState4.apexCore,
      level2 = _getState4$apexCore.level2,
      decimalPlaces = _getState4$apexCore.product.decimalPlaces;
    var selectedInstrument = (0, _instrumentPositionSelectors.selectedInstrumentSelector)(getState());
    var price = (0, _orderHelper.syncPriceWithQuantity)(quantity, {
      level2: level2,
      selectedInstrument: selectedInstrument,
      side: formObj.values.side,
      decimalPlaces: decimalPlaces
    });
    dispatch((0, _reduxForm.change)(form, field, price));
  };
};
var calculateQuantity = function calculateQuantity(initValue, orders, quantityIndex) {
  var buy = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var init = new _bignumber["default"](initValue);
  var quantity = orders.filter(function (data, index) {
    return buy ? index < quantityIndex : index > quantityIndex;
  }).reduce(function (prev, current) {
    return prev.plus(current.Quantity);
  }, init);
  return quantity.toString();
};

/**
 * Switch order type to 'Limit' if 'Market' is selected before
 */
var checkAndSwitchToLimitOrderType = function checkAndSwitchToLimitOrderType() {
  return function (dispatch, getState) {
    var selectedOrderType = getState().form.orderEntry.values.orderType;
    if (selectedOrderType === _orderEntryFormConstants.orderTypes.market.displayName) {
      dispatch((0, _reduxForm.change)('orderEntry', 'orderType', _orderEntryFormConstants.orderTypes.limit.displayName));
    }
  };
};
var clearFeeAndTotalAmountValues = function clearFeeAndTotalAmountValues(form) {
  return function (dispatch) {
    dispatch(clearField(form, 'fee', '0'));
    dispatch(clearField(form, 'totalAmount', '0'));
  };
};
var clearField = function clearField(form, field, initialValue) {
  return function (dispatch) {
    dispatch((0, _reduxForm.change)(form, field, initialValue));
    dispatch((0, _reduxForm.untouch)(form, field));
  };
};